import React from 'react';
import { Check } from 'react-feather';
import './SignatureDisplay.scss';

interface SignatureDisplayProps {
  method: 'text' | 'placeholder' | 'digital';
  textSignature?: string;
  digitalSignature?: string;
  label?: string;
}

export function SignatureDisplay({
  method,
  textSignature,
  digitalSignature,
  label = 'Current Signature',
}: SignatureDisplayProps) {
  return (
    <div className="signature-display">
      <div className="signature-display__label">
        <Check size={16} />
        <span>{label}</span>
      </div>
      <div className="signature-display__content">
        {method === 'text' && textSignature && (
          <span className="signature-display__text">{textSignature}</span>
        )}
        {method === 'digital' && digitalSignature && (
          <img
            src={digitalSignature}
            alt="Digital signature"
            className="signature-display__image"
          />
        )}
        {method === 'placeholder' && (
          <div className="signature-display__placeholder">
            <span>(SIGNATURE)</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SignatureDisplay;
